import React, { Component } from 'react';

class SubTitulo extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let subTitulo = this.props.entidad.DescripcionPlural != undefined ? this.props.entidad.DescripcionPlural : this.props.entidad.Descripcion
        return (
            <div className="row">
                <div className="col-md-12">
                    <h3>Lista de {subTitulo}</h3>
                </div>
            </div>
        );
    }
};

export default SubTitulo